import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { getConfig } from '@utils/config-utils';

import Logo from '@icons/header/logo';

import UnstyledHeading from '@components/shared/unstyled-heading';
import ActionItems from './action-items';
import Links from './links';

import './header.scss';

const Header = ({headerId}) => (
  <div styleName="header-container">
    <div styleName="header-inner-container">
      <UnstyledHeading rank={1} id={headerId} styleName="header-title">
        <span styleName="logo"><Logo/></span>
        <span styleName="label">{getConfig().cityName}</span>
      </UnstyledHeading>
      <Links />
    </div>
    <ActionItems />
  </div>
);

Header.propTypes = {
  headerId: PropTypes.string
};

export default memo(Header);
